import { ArticleStructure } from "../articleElement.js";

const content = [
]

export default {
    content
}